export enum FormType {
  SUBMISSION = 'SUBMISSION',
  REVIEW = 'REVIEW',
  STATEMENT = 'STATEMENT'
}
